
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance/simple-earn",
      function () {
        return require("private-next-pages/finance/simple-earn.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance/simple-earn"])
      });
    }
  